export default "__VITE_ASSET__BfE9qfxP__"